<div class="supplier-list-container" (click)="closeActionMenu()">
  <!-- Ngx UI Loader -->
  <ngx-ui-loader [hasProgressBar]="false" fgsColor="#3E916C"></ngx-ui-loader>
  
  <div class="page-header">
    <h2>Suppliers</h2>
    <button class="btn btn-primary" (click)="showAddSupplierForm()" *ngIf="!showAddForm">
      Add Supplier
    </button>
  </div>

  <!-- Success Notification (Top Right) -->
  <div *ngIf="successMessage" class="success-notification">
    <svg class="success-notification-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" fill="#10b981"/>
      <path d="M8 12L11 15L16 9" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <span class="success-notification-message">{{ successMessage }}</span>
  </div>

  <!-- Error Notification (Top Right) -->
  <div *ngIf="errorMessage" class="error-notification">
    <svg class="error-notification-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" fill="#dc2626"/>
      <path d="M15 9L9 15M9 9L15 15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <span class="error-notification-message">{{ errorMessage }}</span>
  </div>

  <!-- Reset Password Notification (Top Right) -->
  <div *ngIf="resetPasswordNotification" [ngClass]="resetPasswordNotificationType === 'success' ? 'success-notification' : 'error-notification'">
    <svg *ngIf="resetPasswordNotificationType === 'success'" class="success-notification-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" fill="#10b981"/>
      <path d="M8 12L11 15L16 9" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <svg *ngIf="resetPasswordNotificationType === 'error'" class="error-notification-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" fill="#dc2626"/>
      <path d="M15 9L9 15M9 9L15 15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <span [ngClass]="resetPasswordNotificationType === 'success' ? 'success-notification-message' : 'error-notification-message'">{{ resetPasswordNotification }}</span>
  </div>

  <!-- Error Messages -->
  <div *ngIf="error" class="alert alert-danger alert-dismissible">
    {{ error }}
  </div>

  <!-- Search and Filters -->
  <div class="filters-bar">
    <div class="search-box">
      <input type="text" class="search-input" placeholder="Search by Name, Company, Email, or Supplier ID" [(ngModel)]="searchTerm" (input)="onSearch()">
      <span class="search-icon">🔍</span>
    </div>
    <select class="filter-select" [(ngModel)]="selectedCountry" (change)="applyFilters()">
      <option value="">Country</option>
      <option *ngFor="let country of countries" [value]="country">{{ country }}</option>
    </select>
    <select class="filter-select" [(ngModel)]="selectedStatus" (change)="applyFilters()">
      <option value="">Filter by Status</option>
      <option value="Active">Active</option>
      <option value="Inactive">Inactive</option>
    </select>
    <button type="button" class="btn btn-reset" (click)="resetFilters()">Reset</button>
  </div>

  <!-- Add Supplier Modal -->
  <div class="modal-overlay" *ngIf="showAddForm">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>Add Supplier</h3>
        <button type="button" class="modal-close" (click)="cancelForm()">&times;</button>
      </div>
      <form (ngSubmit)="createSupplier()">
        <!-- Company Details Section -->
        <div class="form-section">
          <h4 class="section-title">Company Details</h4>
          <div class="form-row">
            <div class="form-group">
              <label>Company Name<span class="required-asterisk">*</span></label>
              <input type="text" class="form-control" [class.error]="companyNameError" [(ngModel)]="supplierForm.companyName" name="companyName" placeholder="Enter Company Name" required (input)="companyNameError = ''">
              <div *ngIf="companyNameError" class="field-error">{{ companyNameError }}</div>
            </div>
            <div class="form-group">
              <label>First Name<span class="required-asterisk">*</span></label>
              <input type="text" class="form-control" [class.error]="firstNameError" [(ngModel)]="supplierForm.firstName" name="firstName" placeholder="Enter First Name" required (input)="firstNameError = ''">
              <div *ngIf="firstNameError" class="field-error">{{ firstNameError }}</div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>Last Name</label>
              <input type="text" class="form-control" [(ngModel)]="supplierForm.lastName" name="lastName" placeholder="Enter Last Name">
            </div>
            <div class="form-group">
              <label>Role</label>
              <input type="text" class="form-control" [(ngModel)]="supplierForm.role" name="role" value="Supplier" readonly>
            </div>
          </div>
        </div>

        <!-- Contact Information Section -->
        <div class="form-section">
          <h4 class="section-title">Contact Information</h4>
          <div class="form-row">
            <div class="form-group">
              <label>Email ID<span class="required-asterisk">*</span></label>
              <input type="email" class="form-control" [class.error]="emailError" [(ngModel)]="supplierForm.email" name="email" placeholder="Enter Email ID" required (input)="emailError = ''; addSupplierError = ''">
              <div *ngIf="emailError" class="field-error">{{ emailError }}</div>
            </div>
            <div class="form-group">
              <label>Phone No<span class="required-asterisk">*</span></label>
              <div class="phone-input-group">
                <select class="form-control phone-code" [(ngModel)]="supplierForm.phoneCountryCode" name="phoneCountryCode">
                  <option *ngFor="let code of countryCodes" [value]="code.code">{{ code.label }}</option>
                </select>
                <input type="text" class="form-control phone-number" [class.error]="phoneError" [(ngModel)]="supplierForm.phone" name="phone" placeholder="Enter Phone No" required (input)="phoneError = ''">
              </div>
              <div *ngIf="phoneError" class="field-error">{{ phoneError }}</div>
            </div>
          </div>
        </div>

        <!-- Address Section -->
        <div class="form-section">
          <h4 class="section-title">Address</h4>
          <div class="form-row">
            <div class="form-group">
              <label>Address Line 1<span class="required-asterisk">*</span></label>
              <input type="text" class="form-control" [class.error]="addressLine1Error" [(ngModel)]="supplierForm.addressLine1" name="addressLine1" placeholder="Enter Address" required (input)="addressLine1Error = ''">
              <div *ngIf="addressLine1Error" class="field-error">{{ addressLine1Error }}</div>
            </div>
            <div class="form-group">
              <label>Address Line 2</label>
              <input type="text" class="form-control" [(ngModel)]="supplierForm.addressLine2" name="addressLine2" placeholder="Enter Address">
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>City<span class="required-asterisk">*</span></label>
              <input type="text" class="form-control" [class.error]="cityError" [(ngModel)]="supplierForm.city" name="city" placeholder="Enter City" required (input)="cityError = ''">
              <div *ngIf="cityError" class="field-error">{{ cityError }}</div>
            </div>
            <div class="form-group">
              <label>State<span class="required-asterisk">*</span></label>
              <select class="form-control" [class.error]="stateError" [(ngModel)]="supplierForm.state" name="state" required (change)="stateError = ''">
                <option value="">Select State</option>
                <option *ngFor="let state of states" [value]="state">{{ state }}</option>
              </select>
              <div *ngIf="stateError" class="field-error">{{ stateError }}</div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>Country<span class="required-asterisk">*</span></label>
              <select class="form-control" [class.error]="countryError" [(ngModel)]="supplierForm.country" name="country" required (change)="countryError = ''">
                <option value="">Select Country</option>
                <option *ngFor="let country of countries" [value]="country">{{ country }}</option>
              </select>
              <div *ngIf="countryError" class="field-error">{{ countryError }}</div>
            </div>
            <div class="form-group">
              <label>Pincode<span class="required-asterisk">*</span></label>
              <input type="text" class="form-control" [class.error]="pincodeError" [(ngModel)]="supplierForm.pincode" name="pincode" placeholder="Enter Pincode" required (input)="pincodeError = ''">
              <div *ngIf="pincodeError" class="field-error">{{ pincodeError }}</div>
            </div>
          </div>
        </div>

        <!-- Credential Section -->
        <div class="form-section">
          <h4 class="section-title">Credential</h4>
          <div class="form-row">
            <div class="form-group">
              <label>Password<span class="required-asterisk">*</span></label>
              <div class="password-input-wrapper">
                <input [type]="showPassword ? 'text' : 'password'" class="form-control" [class.error]="passwordErrorAdd" [(ngModel)]="supplierForm.password" name="password" placeholder="Enter Password" required minlength="6" (input)="passwordErrorAdd = ''">
                <button type="button" class="password-toggle" (click)="togglePasswordVisibility()">
                  <svg *ngIf="!showPassword" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 3C5 3 1.73 7.11 1 10C1.73 12.89 5 17 10 17C15 17 18.27 12.89 19 10C18.27 7.11 15 3 10 3Z" stroke="#6b7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <circle cx="10" cy="10" r="3" stroke="#6b7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <svg *ngIf="showPassword" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 3C5 3 1.73 7.11 1 10C1.73 12.89 5 17 10 17C15 17 18.27 12.89 19 10C18.27 7.11 15 3 10 3Z" stroke="#6b7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M3 3L17 17" stroke="#6b7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
              </div>
              <div *ngIf="passwordErrorAdd" class="field-error">{{ passwordErrorAdd }}</div>
            </div>
          </div>
        </div>

        <div *ngIf="addSupplierError" class="alert alert-danger">{{ addSupplierError }}</div>
        <div *ngIf="success" class="alert alert-success">{{ success }}</div>
        <div class="modal-footer">
          <button type="button" class="btn btn-cancel" (click)="cancelForm()">Cancel</button>
          <button type="submit" class="btn btn-submit" [disabled]="formLoading">
            {{ formLoading ? 'Submitting...' : 'Submit' }}
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- Edit Supplier Modal -->
  <div class="modal-overlay" *ngIf="showEditModal">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>Edit Supplier</h3>
        <button type="button" class="modal-close" (click)="closeEditModal()">&times;</button>
      </div>
      <form (ngSubmit)="updateSupplier()">
        <!-- Company Details Section -->
        <div class="form-section">
          <h4 class="section-title">Company Details</h4>
          <div class="form-row">
            <div class="form-group">
              <label>Company Name<span class="required-asterisk">*</span></label>
              <input type="text" class="form-control" [(ngModel)]="editForm.companyName" name="editCompanyName" placeholder="Enter Company Name" required>
            </div>
            <div class="form-group">
              <label>First Name<span class="required-asterisk">*</span></label>
              <input type="text" class="form-control" [(ngModel)]="editForm.firstName" name="editFirstName" placeholder="Enter First Name" required>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>Last Name</label>
              <input type="text" class="form-control" [(ngModel)]="editForm.lastName" name="editLastName" placeholder="Enter Last Name">
            </div>
            <div class="form-group">
              <label>Role</label>
              <input type="text" class="form-control" [(ngModel)]="editForm.role" name="editRole" value="Supplier" readonly>
            </div>
          </div>
        </div>

        <!-- Contact Information Section -->
        <div class="form-section">
          <h4 class="section-title">Contact Information</h4>
          <div class="form-row">
            <div class="form-group">
              <label>Email ID<span class="required-asterisk">*</span></label>
              <input type="email" class="form-control" [(ngModel)]="editForm.email" name="editEmail" placeholder="Enter Email ID" required>
            </div>
            <div class="form-group">
              <label>Phone No<span class="required-asterisk">*</span></label>
              <div class="phone-input-group">
                <select class="form-control phone-code" [(ngModel)]="editForm.phoneCountryCode" name="editPhoneCountryCode">
                  <option *ngFor="let code of countryCodes" [value]="code.code">{{ code.label }}</option>
                </select>
                <input type="text" class="form-control phone-number" [(ngModel)]="editForm.phone" name="editPhone" placeholder="Enter Phone No" required>
              </div>
            </div>
          </div>
        </div>

        <!-- Address Section -->
        <div class="form-section">
          <h4 class="section-title">Address</h4>
          <div class="form-row">
            <div class="form-group">
              <label>Address Line 1<span class="required-asterisk">*</span></label>
              <input type="text" class="form-control" [(ngModel)]="editForm.addressLine1" name="editAddressLine1" placeholder="Enter Address" required>
            </div>
            <div class="form-group">
              <label>Address Line 2</label>
              <input type="text" class="form-control" [(ngModel)]="editForm.addressLine2" name="editAddressLine2" placeholder="Enter Address">
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>City<span class="required-asterisk">*</span></label>
              <input type="text" class="form-control" [(ngModel)]="editForm.city" name="editCity" placeholder="Enter City" required>
            </div>
            <div class="form-group">
              <label>State<span class="required-asterisk">*</span></label>
              <select class="form-control" [(ngModel)]="editForm.state" name="editState" required>
                <option value="">Select State</option>
                <option *ngFor="let state of states" [value]="state">{{ state }}</option>
              </select>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>Country<span class="required-asterisk">*</span></label>
              <select class="form-control" [(ngModel)]="editForm.country" name="editCountry" required>
                <option value="">Select Country</option>
                <option *ngFor="let country of countries" [value]="country">{{ country }}</option>
              </select>
            </div>
            <div class="form-group">
              <label>Pincode<span class="required-asterisk">*</span></label>
              <input type="text" class="form-control" [(ngModel)]="editForm.pincode" name="editPincode" placeholder="Enter Pincode" required>
            </div>
          </div>
        </div>

        <div *ngIf="error" class="alert alert-danger">{{ error }}</div>

        <div class="modal-footer">
          <button type="button" class="btn btn-cancel" (click)="closeEditModal()">Cancel</button>
          <button type="submit" class="btn btn-submit" [disabled]="formLoading">
            {{ formLoading ? 'Updating...' : 'Update' }}
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- Success Modal -->
  <div class="modal-overlay success-modal-overlay" *ngIf="showSuccessModal" (click)="closeSuccessModal()">
    <div class="success-modal-content" (click)="$event.stopPropagation()">
      <button type="button" class="success-modal-close" (click)="closeSuccessModal()">&times;</button>
      <div class="success-modal-icon">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="32" cy="32" r="32" fill="#1e3a8a"/>
          <path d="M20 32L28 40L44 24" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="success-modal-message">{{ successModalMessage }}</div>
    </div>
  </div>

  <!-- Reset Password Modal -->
  <div class="modal-overlay" *ngIf="showResetPasswordModalFlag" (click)="closeResetPasswordModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>Reset Password</h3>
        <button type="button" class="modal-close" (click)="closeResetPasswordModal()">&times;</button>
      </div>
      <form (ngSubmit)="resetPassword()">
        <div class="form-row">
          <div class="form-group">
            <label>Password<span class="required-asterisk">*</span></label>
            <input type="password" class="form-control" [class.error]="passwordError" [(ngModel)]="resetPasswordForm.password" name="resetPassword" placeholder="Enter Password" required minlength="6" (input)="onPasswordInput()">
            <div *ngIf="passwordError" class="field-error">{{ passwordError }}</div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-cancel" (click)="closeResetPasswordModal()">Cancel</button>
          <button type="submit" class="btn btn-submit" [disabled]="formLoading">
            {{ formLoading ? 'Resetting...' : 'Reset' }}
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- Suppliers Table -->
  <div class="table-container" #tableContainer *ngIf="!loading && suppliers.length > 0">
    <table class="suppliers-table">
      <thead>
        <tr>
          <th>Supplier ID</th>
          <th>Company</th>
          <th>Email Address</th>
          <th>Shared Products Category</th>
          <th>Active Quotes</th>
          <th>Status</th>
          <th>Timeline</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let supplier of suppliers">
          <td>{{ supplier.supplierId || '--' }}</td>
          <td>
            <div class="company-cell">
              <div class="company-name">{{ supplier.companyName || supplier.name || '--' }}</div>
              <div class="company-location">{{ supplier.city || '' }}{{ supplier.city && supplier.country ? ',' : '' }} {{ supplier.country || '--' }}</div>
            </div>
          </td>
          <td>{{ supplier.email || '--' }}</td>
          <td class="count-cell">{{ formatCount(supplier.sharedCategoriesCount) }}</td>
          <td class="count-cell">{{ formatCount(supplier.activeQuotesCount) }}</td>
          <td>
            <span class="status-badge" [ngClass]="supplier.isActive ? 'status-active' : 'status-inactive'">
              {{ supplier.isActive ? 'Active' : 'Deactive' }}
            </span>
          </td>
          <td class="timeline-cell">
            <div class="timeline-item">Created on : {{ formatDate(supplier.createdAt) }}</div>
            <div class="timeline-item">Updated on : {{ formatDate(supplier.updatedAt) }}</div>
          </td>
          <td>
            <div class="actions-cell">
              <div class="action-menu" (click)="toggleActionMenu(supplier.supplierId, $event); $event.stopPropagation()">
                <span class="dots-icon" title="More actions">⋮</span>
                <div class="action-dropdown" *ngIf="showActionMenu[supplier.supplierId]" (click)="$event.stopPropagation()">
                  <a href="#" class="dropdown-item" (click)="viewSupplier(supplier); $event.preventDefault(); $event.stopPropagation()">
                    View Details
                  </a>
                  <a href="#" class="dropdown-item" (click)="editSupplier(supplier); $event.preventDefault(); $event.stopPropagation()">
                    Edit
                  </a>
                  <a href="#" class="dropdown-item" (click)="showResetPasswordModal(supplier); $event.preventDefault(); $event.stopPropagation()">
                    Reset Password
                  </a>
                  <!-- Deactivate/Activate: Only Admin can access -->
                  <a href="#" class="dropdown-item deactivate" *ngIf="supplier.isActive && authService.isAdmin()" (click)="deactivateSupplier(supplier); $event.preventDefault(); $event.stopPropagation()">
                    Deactivate
                  </a>
                  <a href="#" class="dropdown-item activate" *ngIf="!supplier.isActive && authService.isAdmin()" (click)="activateSupplier(supplier); $event.preventDefault(); $event.stopPropagation()">
                    Activate
                  </a>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    
    <!-- Infinite Scroll Loading Indicator -->
    <div class="infinite-scroll-loader" *ngIf="isLoadingMore">
      <div class="loader-spinner"></div>
      <span>Loading more suppliers...</span>
    </div>
    
    <!-- End of Data Message -->
    <div class="end-of-data" *ngIf="!hasMoreData && !loading && suppliers.length > 0">
      <p>No more suppliers to load</p>
    </div>
  </div>

  <div class="empty-state" *ngIf="!loading && suppliers.length === 0">
    <p>No suppliers found</p>
  </div>

  <div class="loading-state" *ngIf="loading">
    <p>Loading suppliers...</p>
  </div>
</div>

